<app-slide-dialog-layout (dismissed)="dismiss()">
    <div left [translate]="'CLOSE'" i18n="@@CLOSE">Close</div>
    <div title [translate]="'TEXT_SIZE'" i18n="@@TEXT_SIZE">Text size</div>

    <div class="flex w-full flex-col gap-3">
        <label class="flex flex-col gap-3">
            <span class="flex items-center justify-between gap-3">
                <span dcTypography="geist-14-medium" [translate]="'TEXT_SIZE'" i18n="@@TEXT_SIZE">Text size</span>
                <span dcTypography="geist-14-medium">{{ textSizePercentage() }}%</span>
            </span>
            <dc-range-slider
                class="px-3"
                [min]="minimumTextSize"
                [max]="maximumTextSize"
                [step]="textSizeStep"
                [value]="textSizePercentage()"
                [showTicks]="true"
                (valueChange)="changeTextSize($event)"></dc-range-slider>
        </label>
        <button
            type="button"
            dcButton
            variant="outline"
            size="small"
            class="self-end"
            [disabled]="textSizePercentage() === defaultTextSize"
            (click)="resetTextSize()">
            <span [translate]="'RESET'" i18n="@@RESET">Reset</span>
        </button>
    </div>
</app-slide-dialog-layout>
